// extracted by mini-css-extract-plugin
export default {"fieldTitle":"CloneFormModal_fieldTitle__tTzz-","fieldBox":"CloneFormModal_fieldBox__idi54"};